import conditionalRenderingPlugin from "./__render";

export default conditionalRenderingPlugin;
